
// import React, { useState } from 'react';
// import { FaBars, FaTimes, FaGithub, FaLinkedin } from 'react-icons/fa';
// import { HiOutlineMail } from 'react-icons/hi';
// import { BsFillPersonLinesFill } from 'react-icons/bs';
// import Logo from '../assets/logo.png';
// import { Link } from 'react-router-dom';

// const Navbar = () => {
//   const [nav, setNav] = useState(false);
//   const [selectedLink, setSelectedLink] = useState(null);

//   const handleClick = () => setNav(!nav);

//   const handleLinkClick = (index) => {
//     setSelectedLink(index);
//     setNav(false);
//   };

//   return (
//     <div className='fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300'>
//       <div>
//         <img src={Logo} alt="Logo Image" style={{ width: '200px' }} />
//       </div>

//       {/* Menu for laptops */}
//       <ul className='hidden md:flex space-x-4'>
//         {['Home', 'About', 'Skills', 'Work', 'Contact'].map((item, index) => (
//           <li key={index}>
//             <Link
//               to={`/${item.toLowerCase()}`}
//               className={`text-white py-2 px-4 rounded-full hover:bg-green-500 transition-colors duration-300 ${
//                 selectedLink === index ? 'border-b-2 border-yellow-500 font-bold' : ''
//               }`}
//               onClick={() => handleLinkClick(index)}
//             >
//               {item}
//             </Link>
//           </li>
//         ))}
//         <li>
//           <a
//             href='https://drive.google.com/file/d/1f8MCJtJGtEfG8XwE2H0KClnmLI_1E8y3/view?usp=drivesdk'
//             download
//             className='text-white py-2 px-4 rounded-full bg-green-500 hover:bg-green-600 transition-colors duration-300'
//           >
//             Download Resume
//           </a>
//         </li>
//       </ul>

//       {/* Hamburger for mobile */}
//       <div onClick={handleClick} className='md:hidden z-10'>
//         {!nav ? <FaBars /> : <FaTimes />}
//       </div>

//       {/* Mobile menu */}
//       <ul
//         className={
//           !nav
//             ? 'hidden'
//             : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center md:hidden'
//         }
//       >
//         {['Home', 'About', 'Skills', 'Work', 'Contact'].map((item, index) => (
//           <li key={index} className='py-6 text-4xl'>
//             <Link
//               onClick={() => handleLinkClick(index)}
//               to={`/${item.toLowerCase()}`}
//               className={`text-white ${
//                 selectedLink === index ? 'font-bold scale-105' : ''
//               }`}
//             >
//               {item}
//             </Link>
//           </li>
//         ))}
//         <li className='py-6'>
//           <a
//             href='https://drive.google.com/file/d/1f8MCJtJGtEfG8XwE2H0KClnmLI_1E8y3/view?usp=drivesdk'
//             download
//             className='text-white bg-green-500 hover:bg-green-600 transition-colors duration-300 text-lg px-4 py-2 rounded-full'
//           >
//             Download Resume
//           </a>
//         </li>
//       </ul>
      
//       {/* Social icons */}
//       <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
//         <ul>
//           <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600 rounded-full'>
//             <a
//               className='flex justify-between items-center w-full text-gray-300 px-4 py-2 rounded-full'
//               href='https://www.linkedin.com/in/rakesh-gupta-88aa76221/'
//             >
//               Linkedin <FaLinkedin size={30} />
//             </a>
//           </li>
//           <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333] rounded-full'>
//             <a
//               className='flex justify-between items-center w-full text-gray-300 px-4 py-2 rounded-full'
//               href='https://github.com/Rakesh3736Gupta?tab=repositories'
//             >
//               Github <FaGithub size={30} />
//             </a>
//           </li>
//           <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0] rounded-full'>
//             <a
//               className='flex justify-between items-center w-full text-gray-300 px-4 py-2 rounded-full'
//               href='mailto:rakeshgupta3736@gmail.com'
//             >
//               Email <HiOutlineMail size={30} />
//             </a>
//           </li>
//           <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69] rounded-full'>
//             <a
//               className='flex justify-between items-center w-full text-gray-300 px-4 py-2 rounded-full'
//               href='https://drive.google.com/file/d/1f8MCJtJGtEfG8XwE2H0KClnmLI_1E8y3/view?usp=drivesdk'>
//               Resume <BsFillPersonLinesFill size={30} />
//             </a>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Navbar;

import React, { useState } from 'react';
import { FaBars, FaTimes, FaGithub, FaLinkedin } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { BsFillPersonLinesFill } from 'react-icons/bs';
import Logo from '../assets/logo.png';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);

  const handleClick = () => setNav(!nav);

  const handleLinkClick = (index) => {
    setSelectedLink(index);
    setNav(false); // Close the mobile menu when a link is clicked
  };

  // Reset selectedLink if navigating to the home page
  const handleHomeClick = () => {
    setSelectedLink(null);
    setNav(false);
  };

  return (
    <div className='fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300'>
      <div>
        <img src={Logo} alt="Logo Image" style={{ width: '200px' }} />
      </div>

      {/* Menu for laptops */}
      <ul className='hidden md:flex space-x-4'>
        {['Home', 'About', 'Skills', 'Work', 'Contact'].map((item, index) => (
          <li key={index}>
            <Link
              to={`/${item.toLowerCase()}`}
              className={`text-white py-2 px-4 rounded-full hover:bg-green-500 transition-colors duration-300 ${
                selectedLink === index ? 'border-b-2 border-yellow-500 font-bold' : ''
              }`}
              onClick={() => item === 'Home' ? handleHomeClick() : handleLinkClick(index)}
            >
              {item}
            </Link>
          </li>
        ))}
        <li>
          <a
            href='https://drive.google.com/file/d/1f8MCJtJGtEfG8XwE2H0KClnmLI_1E8y3/view?usp=drivesdk'
            download
            className='text-white py-2 px-4 rounded-full bg-green-500 hover:bg-green-600 transition-colors duration-300'
          >
            Download Resume
          </a>
        </li>
      </ul>

      {/* Hamburger for mobile */}
      <div onClick={handleClick} className='md:hidden z-10'>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center md:hidden'
        }
      >
        {['Home', 'About', 'Skills', 'Work', 'Contact'].map((item, index) => (
          <li key={index} className='py-6 text-4xl'>
            <Link
              onClick={() => item === 'Home' ? handleHomeClick() : handleLinkClick(index)}
              to={`/${item.toLowerCase()}`}
              className={`text-white ${
                selectedLink === index ? 'font-bold scale-105' : ''
              }`}
            >
              {item}
            </Link>
          </li>
        ))}
        <li className='py-6'>
          <a
            href='https://drive.google.com/file/d/1f8MCJtJGtEfG8XwE2H0KClnmLI_1E8y3/view?usp=drivesdk'
            download
            className='text-white bg-green-500 hover:bg-green-600 transition-colors duration-300 text-lg px-4 py-2 rounded-full'
          >
            Download Resume
          </a>
        </li>
      </ul>
      
      {/* Social icons */}
      <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
        <ul>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600 rounded-full'>
            <a
              className='flex justify-between items-center w-full text-gray-300 px-4 py-2 rounded-full'
              href='https://www.linkedin.com/in/rakesh-gupta-88aa76221/'
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333] rounded-full'>
            <a
              className='flex justify-between items-center w-full text-gray-300 px-4 py-2 rounded-full'
              href='https://github.com/Rakesh3736Gupta?tab=repositories'
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0] rounded-full'>
            <a
              className='flex justify-between items-center w-full text-gray-300 px-4 py-2 rounded-full'
              href='mailto:rakeshgupta3736@gmail.com'
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69] rounded-full'>
            <a
              className='flex justify-between items-center w-full text-gray-300 px-4 py-2 rounded-full'
              href='https://drive.google.com/file/d/1f8MCJtJGtEfG8XwE2H0KClnmLI_1E8y3/view?usp=drivesdk'>
              Resume <BsFillPersonLinesFill size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
